import { render } from "./subscription_selection.vue?vue&type=template&id=5c08fd0f"
import script from "./subscription_selection.vue?vue&type=script&lang=js"
export * from "./subscription_selection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Site résa/reservation.ogalo-saumurvaldeloire.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__